import React from 'react';

const Privacy: React.FC = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="container mx-auto py-8 md:py-12">
        <h1 className="text-3xl md:text-4xl font-bold text-center mb-8">
          Política de Privacidade
        </h1>
        <p className="text-center text-muted-foreground mb-12">
          Última atualização: 05 de Outubro de 2025
        </p>

        <div className="prose prose-invert max-w-none text-muted-foreground">
          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">1. Introdução</h2>
          <p>
            Bem-vindo à nossa Política de Privacidade. A sua privacidade é de extrema importância para nós.
            Esta política explica como coletamos, usamos, divulgamos e protegemos as suas informações
            pessoais quando você utiliza os nossos serviços. Ao acessar ou usar a nossa plataforma,
            você concorda com os termos desta Política de Privacidade.
          </p>

          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">2. Informações que Coletamos</h2>
          <p>Podemos coletar os seguintes tipos de informações:</p>
          <ul className="list-disc list-inside ml-4">
            <li><strong>Informações de Registro:</strong> Nome, endereço de e-mail, data de nascimento, endereço, número de telefone.</li>
            <li><strong>Informações Financeiras:</strong> Detalhes de pagamento para depósitos e saques (criptografados e processados por terceiros seguros).</li>
            <li><strong>Dados de Uso:</strong> Informações sobre como você interage com a nossa plataforma, incluindo jogos jogados, histórico de apostas, preferências.</li>
            <li><strong>Dados Técnicos:</strong> Endereço IP, tipo de navegador, sistema operacional, dados de localização, informações do dispositivo.</li>
            <li><strong>Comunicações:</strong> Registros de suas comunicações conosco, incluindo e-mails e chats de suporte.</li>
          </ul>

          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">3. Como Usamos Suas Informações</h2>
          <p>Utilizamos as informações coletadas para:</p>
          <ul className="list-disc list-inside ml-4">
            <li>Fornecer e manter nossos serviços.</li>
            <li>Processar transações e gerenciar sua conta.</li>
            <li>Personalizar sua experiência e oferecer conteúdo relevante.</li>
            <li>Melhorar nossos produtos e serviços.</li>
            <li>Comunicar-nos com você sobre atualizações, promoções e suporte.</li>
            <li>Detectar e prevenir fraudes e atividades ilegais.</li>
            <li>Cumprir com obrigações legais e regulatórias.</li>
          </ul>

          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">4. Compartilhamento de Informações</h2>
          <p>
            Não vendemos ou alugamos suas informações pessoais a terceiros. Podemos compartilhar suas
            informações com:
          </p>
          <ul className="list-disc list-inside ml-4">
            <li>Provedores de serviços terceirizados que nos auxiliam na operação da plataforma (processadores de pagamento, provedores de análise de dados).</li>
            <li>Autoridades reguladoras e governamentais, quando exigido por lei.</li>
            <li>Parceiros de negócios, com seu consentimento, para oferecer promoções ou serviços específicos.</li>
          </ul>

          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">5. Cookies e Tecnologias Semelhantes</h2>
          <p>
            Utilizamos cookies e outras tecnologias de rastreamento para melhorar sua experiência,
            analisar o uso da plataforma e personalizar conteúdo e anúncios. Você pode gerenciar
            suas preferências de cookies através das configurações do seu navegador.
          </p>

          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">6. Segurança dos Dados</h2>
          <p>
            Implementamos medidas de segurança técnicas e organizacionais robustas para proteger
            suas informações pessoais contra acesso não autorizado, alteração, divulgação ou destruição.
            Isso inclui criptografia, firewalls e controles de acesso.
          </p>

          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">7. Seus Direitos</h2>
          <p>Você tem o direito de:</p>
          <ul className="list-disc list-inside ml-4">
            <li>Acessar e solicitar uma cópia de suas informações pessoais.</li>
            <li>Solicitar a correção de informações imprecisas.</li>
            <li>Solicitar a exclusão de suas informações pessoais, sujeito a obrigações legais.</li>
            <li>Opor-se ao processamento de suas informações em determinadas circunstâncias.</li>
          </ul>
          <p className="mt-4">
            Para exercer qualquer um desses direitos, entre em contato conosco através dos canais de suporte.
          </p>

          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">8. Alterações a Esta Política</h2>
          <p>
            Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos você sobre
            quaisquer alterações significativas publicando a nova política em nossa plataforma.
            Recomendamos que você revise esta política regularmente.
          </p>

          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">9. Contato</h2>
          <p>
            Se tiver alguma dúvida sobre esta Política de Privacidade ou sobre nossas práticas de privacidade,
            entre em contato conosco através do nosso suporte ao cliente.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
